import React, { useState, useEffect } from 'react';

function LoadingScreen() {
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 1200);
    const hideTimer = setTimeout(() => setVisible(false), 1500);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes kbyPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.08); opacity: 0.7; }
        }
      `}</style>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: '#101010',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999,
          opacity: fading ? 0 : 1,
          transition: 'opacity 0.3s ease',
        }}
      >
        <img
          src="/logo-white.png"
          alt="KBY Interactive"
          style={{
            width: '120px',
            height: 'auto',
            animation: 'kbyPulse 1.4s ease-in-out infinite',
          }}
        />
      </div>
    </>
  );
}

export default LoadingScreen;
